import React from 'react';
import {
  UsersIcon,
  UserGroupIcon,
  MegaphoneIcon,
  PlusIcon,
  ArrowUpTrayIcon,
  ChartBarIcon,
} from '@heroicons/react/24/outline';

const MarketingTabs = ({
  activeTab,
  setActiveTab,
  onAddMember,
  onAddAudience,
  onAddCampaign,
  onBulkImport,
}) => {
  const tabs = [
    { id: 'members', name: 'Audience Members', icon: UsersIcon },
    { id: 'audiences', name: 'Audiences', icon: UserGroupIcon },
    { id: 'campaigns', name: 'Campaigns', icon: MegaphoneIcon },
    { id: 'reports', name: 'Reports', icon: ChartBarIcon },
  ];

  const getAddAction = () => {
    switch (activeTab) {
      case 'members':
        return { label: 'Add Member', onClick: onAddMember };
      case 'audiences':
        return { label: 'Create Audience', onClick: onAddAudience };
      case 'campaigns':
        return { label: 'Create Campaign', onClick: onAddCampaign };
      default:
        return null;
    }
  };

  const addAction = getAddAction();

  return (
    <div className="mb-6">
      <div className="sm:flex sm:items-center sm:justify-between">
        {/* Tabs - horizontally scrollable on mobile */}
        <div className="border-b border-gray-200 overflow-x-auto pb-1">
          <nav className="-mb-px flex space-x-8 min-w-max" aria-label="Tabs">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`
                    ${activeTab === tab.id
                      ? 'border-purple-500 text-purple-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }
                    whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm flex items-center gap-2
                  `}
                >
                  <Icon className="h-5 w-5" />
                  {tab.name}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Action Buttons */}
        <div className="mt-4 sm:mt-0 flex gap-3">
          {activeTab === 'members' && (
            <button
              type="button"
              onClick={onBulkImport}
              className="inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2"
            >
              <ArrowUpTrayIcon className="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />
              Bulk Import
            </button>
          )}
          {addAction && (
            <button
              type="button"
              onClick={addAction.onClick}
              className="inline-flex items-center justify-center rounded-md border border-transparent bg-purple-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2"
            >
              <PlusIcon className="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />
              {addAction.label}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MarketingTabs;

